import React from "react";
import PropTypes from "prop-types";
import { Image } from "@learningblocks/shared-components";
import "./style.scss";

export function TakeAwayWidget(props) {
  return (
    <div className="takeawaywidget">
      <Image
        src={props.image}
        alt={props.alt}
        className="takeawaywidget__image"
      />
      <div className="takeawaywidget__textblock">
        <p className="takeawaywidget__textblock_text">{props.text}</p>
      </div>
    </div>
  );
}

TakeAwayWidget.propTypes = {
  /**
   * Url for image to be displayed on widget
   */
  image: PropTypes.string,
  /**
   * Text description for the widget
   */
  text: PropTypes.string,
};

TakeAwayWidget.propTypes = {};
